__turbopack_context__.v({
  "benefit": "Xhmkxq_benefit",
  "benefitRule": "Xhmkxq_benefitRule",
  "benefitSub": "Xhmkxq_benefitSub",
  "benefitTitle": "Xhmkxq_benefitTitle",
  "benefits": "Xhmkxq_benefits",
  "buy": "Xhmkxq_buy",
  "card": "Xhmkxq_card",
  "cardHead": "Xhmkxq_cardHead",
  "cardIncluded": "Xhmkxq_cardIncluded",
  "cardOptional": "Xhmkxq_cardOptional",
  "eyebrow": "Xhmkxq_eyebrow",
  "grid": "Xhmkxq_grid",
  "icon20": "Xhmkxq_icon20",
  "icon24": "Xhmkxq_icon24",
  "inner": "Xhmkxq_inner",
  "left": "Xhmkxq_left",
  "list": "Xhmkxq_list",
  "optBody": "Xhmkxq_optBody",
  "optCopy": "Xhmkxq_optCopy",
  "optHead": "Xhmkxq_optHead",
  "optPrice": "Xhmkxq_optPrice",
  "optTitle": "Xhmkxq_optTitle",
  "price": "Xhmkxq_price",
  "priceAmount": "Xhmkxq_priceAmount",
  "priceNote": "Xhmkxq_priceNote",
  "right": "Xhmkxq_right",
  "row": "Xhmkxq_row",
  "rowText": "Xhmkxq_rowText",
  "rule": "Xhmkxq_rule",
  "section": "Xhmkxq_section",
  "srOnly": "Xhmkxq_srOnly",
  "sub": "Xhmkxq_sub",
  "title": "Xhmkxq_title",
  "titleFaint": "Xhmkxq_titleFaint",
  "trust": "Xhmkxq_trust",
  "trustItem": "Xhmkxq_trustItem",
  "trustLink": "Xhmkxq_trustLink",
});
